import React, { useEffect, useState } from "react";
import { useCreateUser, useGetUserRoles, useUpdateUser } from "../../../backend/users";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { getValue, preventDefault } from "../../../utils/common";
import { ACTIONS, PATTERNS, STATUS } from "../../common/Constants";
import { Accordion, Button, Modal } from "react-bootstrap";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../common/FormRenderer";
import PageLoader from "../../shared/PageLoader";
import ViewPrivileges from "./Roles/ViewPrivileges";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../common/Table";
import styles from "./UserManagement.module.css";

function UserDetails({ record: data, onClose, onSubmit }: any) {
    const [user, setUser] = useState<any>({ hideButtons: true, status: { value: STATUS.ACTIVE, label: STATUS.ACTIVE } });
    const statuses = [
        { value: 'Active', label: 'Active' },
        { value: 'ChangePassword', label: 'Change Password' },
        { value: 'LoginWithOTP', label: 'Login With OTP' },
        { value: 'Inactive', label: 'Inactive' },
        { value: 'Locked', label: 'Locked' }
    ];

    const { records: roles } = useGetUserRoles({ ...DEFAULT_OPTIONS_PAYLOAD });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'Full Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(user, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'user_name',
                label: 'Username',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(user, 'user_name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'email',
                label: 'Email Address',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.PATTERN, pattern: PATTERNS.EMAIL, message: 'Invalid email address' }
                ],
                content: getValue(user, 'email')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'status',
                label: 'Status',
                content: getValue(user, 'status.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'role',
                label: 'Role',
                isMulti: true,
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(user, 'role.label'),
                options: roles
            }
        ],
    };

    function getTitle() {
      return 'User Details';
    }

    useEffect(() => {
        if (data) {
            const status = statuses.find((x: any) => x.value === data.status);
            setUser({
                ...user,
                ...data,
                role: data.roles.map((role: any) => {
                    return { value: role.id, label: role.name, role }
                }),
                status: status ? status : { value: "", label: "" }
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{getTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={user}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                    {
                        (user.role || []).length > 0 &&
                        <Accordion alwaysOpen={true} className={styles.roleDetails}>
                            {
                                (user.role || []).map(({ value, label, role }: any) => {
                                    return (
                                        <Accordion.Item eventKey={value} key={value}>
                                            <Accordion.Header>{label}</Accordion.Header>
                                            <Accordion.Body>
                                                <ViewPrivileges privileges={role.pages} fullView={false} />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )
                                })
                            }
                        </Accordion>
                    }
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                  {
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                  }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UserDetails;
